define([ // START Open Requre.JS wrapper
	'jquery',
	'pubsub'
	], function($) {

		"use strict";

		// Gets S7 image set from selected color swatch
		var getS7ImageSetName = function(el) {
			var selectedAttribute = $(el).closest('.attr-box.selected'),
				activeContext = $('.product-form-js').find('.active-context-js');

			if(!selectedAttribute.length) {
				selectedAttribute = $('.product-form-js').find('.attr-box').first();
			}

			var imageSetName = activeContext.data('s7ImageSetName') || selectedAttribute.data('s7ImageSetName');

			return imageSetName;
		},

		onSwatchOrContextChange = function(event) {
			// Get the common parent of the swatch or context that was changed on the page, and viewer instance
			var commonParent = $(event.target).parents().has('.vfdp-s7-viewer').first(),
				viewer = $('.vfdp-s7-viewer', commonParent);

			viewer.attr('data-viewer-options', JSON.stringify({"media":{"set":{"asset":getS7ImageSetName(event.target)}}}));
		};

		// A color swatch was clicked
		$.pubsub('subscribe', 'product-form.attr.swatch.click', function(msg, event) {
			onSwatchOrContextChange(event);
		});

		// A color swatch was clicked on stl-modal
		$.pubsub('subscribe', 'stl-modal.product-form.attr.swatch.click', function(msg, event) {
			onSwatchOrContextChange(event);
		});

		// Context was changed
		$.pubsub('subscribe', 'product-form.attr.context.changed', function(msg, event) {
			onSwatchOrContextChange(event);
		});
	}
);

